import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { isIOS } from 'src/utils/device';

@Injectable({ providedIn: 'root' })
export class TokenTransferService {
  private readonly cpsUrl = environment.CPS_URL;
  private readonly cpsDomain = environment.CPS2_DOMAIN.replace(/\/$/, '');

  sendTokensToCps(userProfile: any): void {
    if (!userProfile || isIOS()) {
      return;
    }
    if (window.self !== window.top) return;
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = `${this.cpsUrl}?origin=${encodeURIComponent(window.location.origin)}`;

    iframe.onload = () => {
      requestAnimationFrame(() => {
        iframe.contentWindow?.postMessage(
          { userProfile },
          this.cpsDomain
        );
      });
    };

    document.body.appendChild(iframe);
  }
}
